import {
  Grid,
  FormControl,
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  NativeSelect
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { Pagination, ToggleButton } from "@material-ui/lab";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { LocalContext } from "../../LocalProvider.js";
import { getHeaderToken, isAuthenticated } from "../../store/selectors/navItems.selector";
import { totalPage, pagePerItems, getPaginatedData } from "../../utils/pagination";
import LoadingHOC from "../common/loader/LoadingHOC.component";
import { getPromotionsListHeader } from "../common/TableHeaders";
import { StyledTableCell, useStyles } from "./Promotion.styles";
import { selectedLanguage } from "../../store/selectors/language.selector";
import { getPromotionData, updateAttachmentCount } from "../../store/actions/promotion.action";
import { getProjectSearchFields, getFormatedDate } from "../common/helper/helper"

export const PromotionContext = createContext({
  setPromotionDetailData: () => {}
});

const PromotionContextProvider = (props) => {
  const token = useSelector(getHeaderToken);
  const isAuth = useSelector(isAuthenticated);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const { translate } = useContext(LocalContext);
  const classes = useStyles();
  const { setLoading } = props;
  const [promotionData, setPromotionData] = useState([]);
  const [promotionDataProvider, setPromotionDataProvider] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [promotionDetailData, setPromotionDetailData] = useState([]);
  const [attachmentStatus, setAttachmentStatus] = useState([]);
  const [dealerResponse, setDealerResponse] = useState("");
  const [dealerResponseStatus, setDealerResponseStatus] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");
  const selectedLocLanguage = useSelector(selectedLanguage);
  const { promotionId } = useParams();
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [projectSearchCategoryField, setProjectSearchCategoryField] = useState("");
  const [projectSearchTextField, setProjectSearchTextField] = useState("");
  const [projectSearchResponse, setProjectSearchResponse] = useState("");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [payload, setPayload] = useState({
    offset: (page - 1) * pagePerItems,
    limit: pagePerItems,
    mu: "",
    ru: "",
    au: "",
    promotion_id: promotionId ? promotionId : ""
  });

  const getAllProjectSearchFields = getProjectSearchFields();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  // SET DEFAULT SEARCH FIELD TO 0 INDEX (DEFAULT : PROJECT CODE)
  const getDefaultSelectedSearchField = useCallback(() => {
    setProjectSearchCategoryField(getAllProjectSearchFields[0]);
  }, [getAllProjectSearchFields]);

  // Update Attachment Status
  const updateAttachmentStatus = (token, fileId, dealerId) => {
    setLoading(true);
    let attachmentPayload = {
      documentId: fileId,
      promotionId: promotionId,
      dealerId: dealerId,
      action: "readCount",
      dealerResponse: ""
    };

    dispatch(updateAttachmentCount(token, attachmentPayload)).then((res) => {
      setLoading(false);
      if (res && res.success === false) {
        setErrorMsg(res.errorMsg);
        setSuccessMsg("");
        setAttachmentStatus([]);
      } else {
        setSuccessMsg(res.successMsg);
        if(res?.attachments?.length > 0) {
          setAttachmentStatus(res.attachments);
        }
        setErrorMsg("");
      }
    })
    .catch((err) => {
      setSuccessMsg("");
      setAttachmentStatus([]);
      setErrorMsg(err);
    });
  };

  // Update Dealer Response
  const updateDealerResponse = (token, fileId, dealerId, responseStatus) => {
    setLoading(true);
    let dealerPayload = {
      documentId: fileId,
      promotionId: promotionId,
      dealerId: dealerId,
      action: "dealerResponse",
      dealerResponse: responseStatus
    };

    dispatch(updateAttachmentCount(token, dealerPayload)).then((res) => {
      setLoading(false);
      if (res && res.success === false) {
        setErrorMsg(res.errorMsg);
        setSuccessMsg("");
        setDealerResponse("");
      } else {
        if(promotionDetailData?.length > 0) { // To Update Dealer Response In Listing API From Detail Page
          let oldPromotionDetailData = promotionDetailData[0];
          setPromotionDetailData([{  ...oldPromotionDetailData, dealerResponse: responseStatus }])
        }
        setDealerResponse(responseStatus);
        setSuccessMsg(res.successMsg);
        setErrorMsg("");
      }
    })
    .catch((err) => {
      setSuccessMsg("");
      setDealerResponse("");
      setErrorMsg(err);
    });
  };

  const handleChangePagination = (event, value) => {
    if (value !== page) {
      setLoading(true);
      setPage(value);
      setPayload({ ...payload, offset: (value - 1) * payload.limit })
    }
  };

  const handleSetPromotionDetails = (promotionDetails) => {
    setPromotionDetailData(promotionDetails);
  }

  const handelSetAttachmentAction = (fileId, dealerId) => {
    updateAttachmentStatus(token, fileId, dealerId);
  }

  const handleDealerResponse = (fileId, dealerId, responseStatus) => {
    updateDealerResponse(token, fileId, dealerId, responseStatus);
  }

  const handleChangeProjectCategoryField = (event) => {
    setProjectSearchCategoryField(event.target.value);
  }

  const handleChangeProjectTextSearch = (event) => {
    setProjectSearchTextField(event.target.value);
  }

  const handleChangeProjectResponse = (event) => {
    setProjectSearchResponse(event.target.value);
  }

  const getProjectAllData = useCallback(() => {
    return dispatch(getPromotionData(token, payload)).then((res) => {
      setLoading(false);
      if (res && res.success === false) {
        setErrorMsg(res.errorMsg);
        setPromotionData([]);
        setPromotionDataProvider([]);
        setDealerResponseStatus(res?.dealerResponse || []);
        setTotalPageCount(0);
      } else {
        setPromotionData(res?.data);
        setDealerResponseStatus(res?.dealerResponse || []);
        const paginatedData = getPaginatedData(res.data, pagePerItems, 1);
        setPromotionDataProvider(paginatedData);
        setPromotionDetailData([]);
        setTotalPageCount(totalPage(res?.totalCount, pagePerItems));
        if(promotionId && paginatedData.length > 0) {
          const singlePromotionData = paginatedData.filter((singleData) => {
            return singleData.promotion.promotionId == promotionId;
          })
          setPromotionDetailData(singlePromotionData);            
        }
        setErrorMsg("");
      }
    });
  }, [token, isAuth, payload, dispatch]);

  const handleChangeDateFrom = (date) => {
    date ? setDateFrom(getFormatedDate(date, "YYYY-MM-DD")) : setDateFrom(null);
  };
  
  const handleChangeDateTo = (date) => {
    date ? setDateTo(getFormatedDate(date, "YYYY-MM-DD")) : setDateTo(null);
  };

  const handleChangeReset = () => {
    setProjectSearchCategoryField("");
    setProjectSearchTextField("");
    setProjectSearchResponse("");
    setPage(1);
    setDateFrom(null);
    setDateTo(null);
    setPayload({
      ...payload,
      offset: 0,
      limit: pagePerItems,
      project_name: "",
      project_code: "",
      dealer_response: "",
      start_date: "",
      end_date: "",
    });
  };

  const handleChangeSearch = () => {
    setPage(1);
    setPayload({
      ...payload,
      offset: 0,
      limit: pagePerItems,
      project_code: projectSearchCategoryField.includes("Project Code") ? projectSearchTextField : "",
      project_name: projectSearchCategoryField.includes("Project Name") ? projectSearchTextField : "",
      dealer_response: projectSearchResponse,
      start_date: dateFrom,
      end_date: dateTo,
    });
  };

  useEffect(() => {
    setLoading(true);
    getProjectAllData();
    !projectSearchCategoryField && getDefaultSelectedSearchField(); // FOR INITIAL SELECTION AS PROJECT CODE
  }, [payload, selectedLocLanguage]);

  return promotionDataProvider ? (
    <>
      <PromotionContext.Provider
        value={{
          promotionDataProvider,
          handleSetPromotionDetails,
          promotionDetailData,
          handelSetAttachmentAction,
          handleDealerResponse,
          dealerResponse,
          attachmentStatus,
          errorMsg,
          successMsg,
          getPromotionsListHeader,
          setLoading,
          setErrorMsg
        }}
      >
        <div className={classes.root}>
          {!promotionId ? (
            <>
              <Grid
                container
                spacing={4}
                className={`${classes.root} ${classes.headerGridContainer}`}
              >
                <Grid item md={3} xs={12}>
                  <Paper
                    className={`${classes.paperHeaderGridLeft} ${classes.paperHeaderGrid}`}
                  >
                    <h2 className={classes.titleSummary}>
                      {translate("My Project")}
                    </h2>
                    <ToggleButton
                      value="Toggle"
                      aria-label="Toggle"
                      className={`${classes.BtnTransparentBG} ${classes.onlyMobile} ${classes.toggleMobile}`}
                      onClick={toggle}
                    >
                      Filter
                      <ExpandLessIcon />
                    </ToggleButton>
                  </Paper>
                </Grid>
                
                <Grid
                  item
                  md={9}
                  xs={12}
                  className={
                    isOpen
                      ? `${classes.headerGridRight} ${classes.paperHeaderGrid} ${classes.headerGridRightMobile} ${classes.headerGridRightMobileActive}`
                      : `${classes.headerGridRight} ${classes.paperHeaderGrid} ${classes.headerGridRightMobile}`
                  }
                >
                  <Paper className={classes.paper} align="right">
                    <form className={classes.formContainer} noValidate>                  
                      <FormControl className={`${classes.formControl} ${classes.searchField}`}>
                        <NativeSelect
                          value={projectSearchCategoryField}
                          onChange={(e) => handleChangeProjectCategoryField(e)}
                          className={classes.selectEmpty}
                        >
                          {getAllProjectSearchFields
                            ? getAllProjectSearchFields.map((searchField, index) => (
                                <option value={searchField} key={index}>
                                  {translate(searchField)}
                                </option>
                              ))
                            : null}
                        </NativeSelect>
                        <TextField
                          id="project-search"
                          placeholder={translate("Search")}
                          value={projectSearchTextField}
                          className={classes.textField}
                          onChange={(e) => handleChangeProjectTextSearch(e)}
                        />
                      </FormControl>
                      <FormControl className={classes.formControl}>
                        <NativeSelect
                          value={projectSearchResponse}
                          onChange={(e) => handleChangeProjectResponse(e)}
                          className={classes.selectEmpty}
                        >
                          <option value="">{translate("Dealer Response")}</option>                      
                          {dealerResponseStatus
                            ? dealerResponseStatus.map((dealerResponse, index) => (
                              <option value={dealerResponse} key={index}>
                                {translate(dealerResponse)}
                              </option>
                            ))
                          : null}
                        </NativeSelect>
                      </FormControl>

                      <FormControl className={classes.formControl}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={classes.textFieldCalendar}
                            disableToolbar
                            inputVariant="standard"
                            variant="inline"
                            format="yyyy-MM-dd"
                            id="datetime-start"
                            placeholder={translate("Start Date")}
                            value={dateFrom}
                            onChange={(date) => handleChangeDateFrom(date)}
                            autoOk
                            // disableFuture
                            error={false}
                            helperText={null}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                      <FormControl className={classes.formControl}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={classes.textFieldCalendar}
                            disableToolbar
                            inputVariant="standard"
                            variant="inline"
                            format="yyyy-MM-dd"
                            id="datetime-to"                        
                            placeholder={translate("End Date")}
                            value={dateTo}
                            onChange={(date) => handleChangeDateTo(date)}
                            autoOk
                            // disableFuture
                            error={false}
                            helperText={null}
                            minDate={new Date(dateFrom)}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                      <Button
                        className={classes.storeFilterBtn}
                        onClick={() => handleChangeSearch()}
                        variant="contained"
                      >
                        {translate("Search")}
                      </Button>
                      <Button
                        className={classes.storeFilterBtn}
                        onClick={() => handleChangeReset()}
                        variant="contained"
                      >
                        {translate("Reset")}
                      </Button>
                    </form>
                  </Paper>
                </Grid>            
              </Grid>

              <TableContainer
                component={Paper}
                className={classes.tableContainerStyle}
                key={1}
              >
                <Table className={classes.table} aria-label="caption table">
                  {getPromotionsListHeader && getPromotionsListHeader.length > 0 &&
                    <TableHead>
                      <TableRow>
                        {getPromotionsListHeader.map((singleHeader, index) => {
                          return <StyledTableCell>
                            <div key={index} align={singleHeader.align ? singleHeader.align : "left"}>
                              {translate(singleHeader.name)}
                            </div>
                          </StyledTableCell>
                        })
                        }
                      </TableRow>
                    </TableHead>
                  }
                  {props.children}
                </Table>
              </TableContainer>

              <div className={classes.buttonStyle}>
                <Pagination
                  className={classes.pagination}
                  size="large"
                  count={totalPageCount}
                  page={page}
                  onChange={(e, value) => handleChangePagination(e, value)}
                  color="primary"
                  showFirstButton
                  showLastButton
                  boundaryCount={2}
                />
              </div>
            </>
          ) : props.children}
        </div>
      </PromotionContext.Provider>
    </>
  ) : null;
};

export default LoadingHOC(PromotionContextProvider);